import React, {useRef} from "react";
import { motion, useInView } from "framer-motion";

const Historia = () => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once:true,margin: "-100px" });
  
  return (
    <motion.div
      id="historia"
      ref={ref}
      className="max-w-6xl mx-auto p-6 mt-20"
      initial={{ opacity: 0, y: 30 }}
      animate={isInView ? { opacity: 1, y: 0 }:{}}
      transition={{ duration: 0.8 }}
    >
      <h1 className="text-4xl font-bold text-center text-blue-700 mb-10">
        Historia de la Institución Educativa “La Inmaculada”
      </h1>

      {/* SECCIÓN - FUNDACIÓN */}
      <section className="mb-12 flex flex-col md:flex-row items-center gap-6">
        <div className="md:w-1/2">
          <h2 className="text-2xl font-semibold text-blue-600 mb-4">
            Fundación
          </h2>
          <p className="text-gray-800 text-justify">
            El colegio fue fundado el 25 de marzo de 1964 mediante Resolución
            Suprema N° 285-1964 como Colegio Nacional de Mujeres “La
            Inmaculada”. Su conducción fue encargada a la Congregación de las
            Hermanas Misioneras de la Inmaculada Concepción, bajo la dirección
            de la Reverenda Madre Jacqueline Breault Breault.
          </p>
        </div>
        <div className="md:w-1/2 h-[300px] w-full md:h-[300px] flex items-center justify-center">
          <img
            src="/imagenes/historia1.webp"
            alt="Fundación del colegio"
            className="object-cover w-full h-full rounded-xl shadow-md transition-transform duration-500 hover:scale-105"
          />
        </div>
      </section>

      {/* SECCIÓN - EXPANSIÓN */}
      <section className="mb-12 flex flex-col md:flex-row-reverse items-center gap-6">
        <div className="md:w-1/2">
          <h2 className="text-2xl font-semibold text-blue-600 mb-4">
            Crecimiento y Expansión
          </h2>
          <p className="text-gray-800 text-justify mb-2">
            En 1976 se inicia la coeducación. Debido a la superpoblación
            escolar, surgieron anexos que más tarde se convirtieron en
            instituciones independientes:
          </p>
          <ul className="list-disc list-inside text-gray-800 ml-4">
            <li>1973: Colegio Estatal Mixto Barrio El Arenal (CEMBA)</li>
            <li>1980: Colegio “Coronel Pedro Portillo”</li>
            <li>1990: Colegio “Nuestra Señora de Guadalupe”</li>
          </ul>
        </div>
        <div className="md:w-1/2 h-[300px] w-full md:h-[300px] flex items-center justify-center">
          <img
            src="/imagenes/historia2.webp"
            alt="Expansión del colegio"
            className="object-cover w-full h-full rounded-xl shadow-md transition-transform duration-500 hover:scale-105"
          />
        </div>
      </section>

      {/* SECCIÓN - EDUCACIÓN NOCTURNA */}
      <section className="mb-12 flex flex-col md:flex-row items-center gap-6">
        <div className="md:w-1/2">
          <h2 className="text-2xl font-semibold text-blue-600 mb-4">
            Educación Nocturna
          </h2>
          <p className="text-gray-800 text-justify">
            En 1973 se anexó la sección nocturna, inicialmente coordinada por la
            Sra. Sara Velarde. Posteriormente, su gestión fue continuada por
            otros docentes destacados. Actualmente, la sección nocturna es
            dirigida por el Mg. Max Henry Arévalo Acosta.
          </p>
        </div>
        <div className="md:w-1/2 h-[300px] w-full md:h-[300px] flex items-center justify-center">
          <img
            src="/imagenes/historia3.webp"
            alt="Educación nocturna"
            className="object-cover w-full h-full rounded-xl shadow-md transition-transform duration-500 hover:scale-105"
          />
        </div>
      </section>

      {/* SECCIÓN - DIRECTORES */}
      <section className="mb-12 flex flex-col md:flex-row items-center gap-6">
        <div className="md:w-1/2 h-[300px] w-full md:h-[300px] flex items-center justify-center mb-6">
          <img
            src="/imagenes/historia4.webp"
            alt="Directores del colegio"
            className="object-cover w-full h-full rounded-xl shadow-md transition-transform duration-500 hover:scale-105"
          />
        </div>
        <div>
        <h2 className="text-2xl font-semibold text-blue-600 mb-4">
          Directores
        </h2>
        <ul className="list-disc list-inside text-gray-800 ml-4 space-y-1">
          <li>Jacqueline Breault (1964 – 1974)</li>
          <li>María Luisa Dávila de Reyna (1974 – 1975)</li>
          <li>Sor Clelia Del Águila Del Castillo (1976 – 1980)</li>
          <li>Clotilde Salazar de Hidalgo (1980 – 1981)</li>
          <li>Berta Acho Chávez de Ramírez (1982 – 1992)</li>
          <li>Yolanda Clemencia Cárdenas Farfán (1992 – 1995)</li>
          <li>Rafael López Napan (1995 – 1998, y desde 2009)</li>
          <li>Irma Reátegui Vela (1999)</li>
          <li>Elsita del Carmen Donayre Gómez</li>
          <li>Cristina Rosario Valera Cívico (Mayo 2000 a Febrero del 2002)</li>
          <li>Freddy Alberto Quispe Mendoza (2018)</li>
          <li>Lidia López Navarro (2020)</li>
          <li>Araceli Pinedo Castro(encargo por cese)</li>
          <li>Dr. Oscar Manuel Gómez Arroyo (Actual, hasta 2028)</li>
        </ul>
        </div>
      </section>
    </motion.div>
  );
};

export default Historia;
